'use client'



import UserMenu from './UserMenu'
import NavbarSearch from "./navbarSearch";

import LogoComponent from '../Logo/Logo'






export const NavBar = () => {


    return (
        <div className="w-[100%] h-[75px] border-b border-gray-200 justify-end items-center flex flex-row gap-lg z-[20] relative bg-white ">
            <div className={'flex items-center select-none pl-xxl'}>
                <LogoComponent/>
            </div>


                <div className="justify-end items-center gap-sm flex flex-grow pr-xxl">


                    <NavbarSearch  />
                    <UserMenu/>


            </div>
        </div>
    )
}





